import { createContext, useContext, useState, useEffect } from "react";

const LangContext = createContext(null);

const LANGUAGES = [
  { code: "pt", label: "Português", flag: "🇧🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("newsky-lang") || "pt");

  useEffect(() => {
    localStorage.setItem("newsky-lang", lang);
    document.documentElement.lang = lang === "pt" ? "pt-BR" : lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, LANGUAGES }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}

export { LANGUAGES };
